
<h2>Set New Password</h2>
<p>Reset password for: <strong>{{email}}</strong>.</p>
<p>If this is this not you, please <a routerLink="/auth/login" data-testid="reset-password-click-here">click here</a> to return to the Login page.</p>

<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  autocomplete="off"
  class="text-left mt-4 pb-4"
  data-testid="reset-password-form">
    <div>
        <div class="form-group">
          <input
              [formControl]="password"
              class="form-control validation-field"
              placeholder="New Password"
              type="password"
              autocomplete="new-password"
              #passwordField
              data-testid="reset-password-password">
          <ng-container *ngIf="form.get('password').touched">
            <small
              *ngIf="form.get('password').hasError('required'); else otherPassErrors"
              class="text-danger"
            >
              New Password is required
            </small>

            <ng-template #otherPassErrors>
              <small
                class="text-danger"
                *ngIf="form.get('password').hasError('minlength')"
              >
                Passwords must be minimum of 8 characters
              </small>

              <small
                class="text-danger"
                *ngIf="form.get('password').hasError('strong')"
              >
                <div *ngIf="form.get('password').hasError('upper')">At least 1 uppercase letter required</div>
                <div *ngIf="form.get('password').hasError('lower')">At least 1 lowercase letter required</div>
                <div *ngIf="form.get('password').hasError('number')">At least 1 number required</div>
              </small>
            </ng-template>
          </ng-container>
      </div>

      <div class="form-group">
        <input
            [formControl]="confirmPassword"
            class="form-control validation-field"
            placeholder="Confirm New Password"
            type="password"
            #confirmPasswordField
            data-testid="reset-password-confirm-password">
        <small
          *ngIf="form.get('confirmPassword').touched && form.get('confirmPassword').hasError('required')"
          class="text-danger"
        >
          Confirm Password is required
        </small>

        <small
          *ngIf="form.get('confirmPassword').touched && form.get('confirmPassword').hasError('mismatch')"
          class="text-danger"
        >
          Passwords do not match
        </small>
      </div>
    </div>

    <div
      *ngIf="message"
      class="success-message"
      role="alert"
    >
      {{message}}
    </div>

    <div *ngIf="errorMessage" role="alert" class="error-message">
        <div class="d-flex flex-nowrap">
            <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
            <span class="mx-1">{{errorMessage}}</span>
            <span class="fa fa-exclamation-triangle align-self-center mx-2"></span>
        </div>
    </div>

    <div class="d-flex justify-content-between mt-6">
      <div
        class="text-button"
        [class.is-loading]="isSending || !isResendEnabled"
        (click)="resend()"
        data-testid="reset-password-resend-password-reset-email">
        <span *ngIf="!isSending && isResendEnabled">Resend Password Reset Email</span>
        <span *ngIf="!isSending && !isResendEnabled">Please check your email...</span>
        <span *ngIf="isSending">Resending email...</span>
      </div>

      <button
        [disabled]="!form.valid || isLoading || isPasswordResetComplete"
        class="btn btn-primary" type="submit"
        data-testid="reset-password-wait-save-new-password">
        <span *ngIf="isLoading; else notLoading">Please wait...</span>
        <ng-template #notLoading>
          <span *ngIf="!isPasswordResetComplete">Save New Password</span>
          <span *ngIf="isPasswordResetComplete">Password Reset Complete</span>
        </ng-template>
      </button>
    </div>
</form>



// WEBPACK FOOTER //
// ./src/app/auth/forgot-password/reset-password/reset-password.component.html